/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkflowTriggerEventDto } from '../../models/workflow-trigger-event-dto';

export interface AutomatedProcessGetAllTriggerEvents$Params {
}

export function automatedProcessGetAllTriggerEvents(http: HttpClient, rootUrl: string, params?: AutomatedProcessGetAllTriggerEvents$Params|null|undefined, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkflowTriggerEventDto>>> {
  const rb = new RequestBuilder(rootUrl, automatedProcessGetAllTriggerEvents.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkflowTriggerEventDto>>;
    })
  );
}

automatedProcessGetAllTriggerEvents.PATH = '/automated-process/workflow-trigger/trigger-event';